import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {QuestionnairesSurveysService} from "../../services/questionnaires-surveys.service";
import {ErrorHandlerService} from "../../services/error-handler.service";
import {SnackBarService} from "../../services/snack-bar.service";
import {v4 as uuid} from 'uuid';
import {Session} from "../../services/Session";
import FroalaEditor from 'froala-editor';
import {FroalaEditorModule, FroalaViewModule} from "angular-froala-wysiwyg";
import {MatCardModule} from "@angular/material/card";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatButtonModule} from "@angular/material/button";
import {MatInputModule} from "@angular/material/input";
import {MatSidenavModule} from "@angular/material/sidenav";
import {MatTabsModule} from "@angular/material/tabs";
import {MatIconModule} from "@angular/material/icon";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatBadgeModule} from "@angular/material/badge";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatMenuModule} from "@angular/material/menu";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {MatListModule} from "@angular/material/list";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatBottomSheetModule} from "@angular/material/bottom-sheet";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatNativeDateModule, MatOptionModule} from "@angular/material/core";
import {MatSelectModule} from "@angular/material/select";
import {MatRadioModule} from "@angular/material/radio";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {DragDropModule} from "@angular/cdk/drag-drop";
import {MatTableModule} from "@angular/material/table";
import {MatSortModule} from "@angular/material/sort";
import {MatChipsModule} from "@angular/material/chips";
import {MatDividerModule} from "@angular/material/divider";
import {TextFieldModule} from "@angular/cdk/text-field";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import { environment } from '../../../environments/environment';

declare const _: any;

export interface DialogData {
  action: string;
  clientLabels: Array<any>;
  questionnaireId: string;
  questionObj: any;
  index: string;
}

@Component({
  selector: 'app-add-edit-question',
  standalone: true,
  imports: [CommonModule, FormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    MatSidenavModule,
    MatTabsModule,
    MatIconModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatBadgeModule,
    MatTooltipModule,
    MatMenuModule,
    ScrollingModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatBottomSheetModule,
    MatSlideToggleModule,
    MatOptionModule,
    MatSelectModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    DragDropModule,
    MatTableModule,
    MatSortModule,
    MatDialogModule,
    MatChipsModule,
    MatDividerModule,
    TextFieldModule,
    MatExpansionModule,
    MatAutocompleteModule,
    MatSelectModule,FroalaEditorModule, FroalaViewModule],
  templateUrl: './add-edit-question.component.html',
  styleUrl: './add-edit-question.component.scss'
})
export class AddEditQuestionComponent implements OnInit {
  constructor(
    private qsService: QuestionnairesSurveysService,
    public dialogRef: MatDialogRef<AddEditQuestionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private snackBar: SnackBarService,
    private errorHandler: ErrorHandlerService
  ) {
    dialogRef.disableClose = true;
  }

  selectedType = 'Short Answer';
  qTypes = [
    {name: 'Short Answer'},
    {name: 'Long Answer'},
    {name: 'Multiple Choice'},
    {name: 'Check Boxes'},
    {name: 'Rating'},
    {name: 'Date'}
  ];
  org = Session.getOrg() ? Session.getOrg() : '';
  userId = Session.getUser().id ? Session.getUser().id : '';
  editorObj = {
    autofocus: true,
    listAdvancedTypes: false,
    linkAlwaysBlank: true,
    enter: FroalaEditor.ENTER_DIV,
    key: environment.froalaKey,
    pasteDeniedAttrs: ['class', 'id', 'style'],
    inlineMode: false,
    toolbarButtons: ['bold', 'italic', 'underline', 'formatOL', 'formatUL', 'alignLeft', 'alignCenter', 'alignRight', 'alignJustify', 'outdent', 'indent'],
    toolbarSticky: false,
    toolbarBottom: true,
    toolbarStickyOffset: 10,
    placeholderText: 'Type Your Question Here ...',
    charCounterCount: false,
    quickInsertTags: [],
    attribution: false,
    toolbarContainer: '.question-menu',
    linkList: [
      {
        text: 'Google',
        href: 'http://google.com',
        target: '_blank',
        rel: 'nofollow'
      }
    ],
    zIndex: 999,
    theme: 'royal',
    fontSize: ['8', '10', '12', '14', '15', '16', '18'],
    fontSizeDefaultSelection: '15',
    fontFamily: {
      'Poppins-Regular': 'poppins',
      Karla: 'Karla',
      NiveauGrotesk: 'NiveauGrotesk',
    },
    fontFamilySelection: true,
    fontFamilyDefaultSelection: 'poppins',
    imageUploadRemoteUrls: false,
  };
  @ViewChild('newQuestionEditor') private newQuestionEditor: ElementRef;
  loader: boolean;
  selectedLabels: Array<any> = [];
  removable = true;

  ngOnInit(): void {
    this.data.questionObj.questionNo = this.data.index + 1;
    if (this.data.action === 'edit') {
      this.selectedLabels = _.map(this.data.questionObj.appliedTo, 'labelId');
      // this.data.questionObj.questionNo = this.data.index;
      this.selectedType = this.data.questionObj.type;
    }
  }

  changeQsType($event): void {
    this.data.questionObj.type = $event.value;
    if ($event.value === 'Short Answer') {
      this.data.questionObj.placeholder = 'Short Answer Text';
    } else if ($event.value === 'Long Answer') {
      this.data.questionObj.placeholder = 'Long Answer Text';
    }
  }

  addRadioBtn(count): void {
    while (count > 0) {
      const obj = {
        id: uuid(),
        value: ''
      };
      this.data.questionObj.multipleOptions.push(obj);
      count--;
    }
  }

  spliceRadioBtn(rdx): void {
    this.data.questionObj.multipleOptions.splice(rdx, 1);
  }

  addCheckbox(count): void {
    while (count > 0) {
      const obj = {
        id: uuid(),
        value: ''
      };
      this.data.questionObj.checkboxes.push(obj);
      count--;
    }
  }

  spliceCheckbox(cdx): void {
    this.data.questionObj.checkboxes.splice(cdx, 1);
  }

  addAppliedLabels($event): void {
    this.selectedLabels = $event.value;
    this.data.questionObj.appliedTo = _(this.data.clientLabels)
      .keyBy('labelId')
      .at(this.selectedLabels)
      .value();
    /* Alternative Way for filtering
    const arr = _.filter(this.data.clientLabels, (label) => {
        return _.includes(this.selectedLabels, label.labelId);
    }); */
  }

  removeLabel(labelId): void {
    this.selectedLabels = _.filter(this.selectedLabels,  (label) => {
      return label !== labelId;
    });
    this.data.questionObj.appliedTo =  _.filter(this.data.questionObj.appliedTo, (label) => {
      return label.labelId !== labelId;
    });
  }

  onAdd(): void {
    this.loader = true;
    this.data.questionObj.question = this.newQuestionEditor.nativeElement.innerText;
    this.qsService.addNewQuestion(this.userId, this.org, this.data.questionnaireId, this.data.questionObj)
      .subscribe((response) => {
        this.onResponse(response, 'Added');
      }, error => {
        this.loader = false;
        this.errorHandler.handleError(error);
      });
  }

  onUpdate(): void {
    this.loader = true;
    this.data.questionObj.question = this.newQuestionEditor.nativeElement.innerText;
    this.qsService.updateQuestion(this.userId, this.org, this.data.questionnaireId, this.data.questionObj)
      .subscribe((response) => {
        this.onResponse(response, 'Updated');
      }, error => {
        this.loader = false;
        this.errorHandler.handleError(error);
      });
  }

  onDelete(): void {
    this.loader = true;
    this.qsService.deleteQuestion(this.userId, this.org, this.data.questionnaireId, this.data.questionObj.id)
      .subscribe((response) => {
        this.onResponse(response, 'Deleted');
      }, error => {
        this.loader = false;
        this.errorHandler.handleError(error);
      });
  }

  onResponse(response, type): void {
    this.data.questionObj = Object.assign(this.data.questionObj, response);
    this.dialogRef.close(this.data);
    this.snackBar.showNotification(`${type} Successfully`, 'success');
    this.loader = false;
  }

}
